import { Magic } from "@/services/persea-user/persea-user-type";

export const signMTX = async (
    sender: string,
    metaTransactionType: object | string,
    magic?: Magic | undefined
    ): Promise<string> => {

    if (typeof metaTransactionType === "string") {
        return metaTransactionType;
    }

    if (!magic) {
        throw new Error('Magic is not defined');
    }

    const isLoggedIn = await magic.user.isLoggedIn();
        
    if (!isLoggedIn) {
        throw new Error('User is not logged in or expired session');
    }
    
    const params = [sender, metaTransactionType];
    const method = 'eth_signTypedData_v4';

    const signature = await magic.rpcProvider.request({
        method,
        params,
    });

    if (!signature) {
        throw new Error("Error signing data");
    }
    
    return signature;
};